import { render, staticRenderFns } from "./GeolocationList.vue?vue&type=template&id=62621670"
import script from "./GeolocationList.vue?vue&type=script&lang=js"
export * from "./GeolocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports